import React, { useEffect, useState } from 'react';
import { ApiResponse } from '../types';
import { apiFetch } from '../lib/apiFetch';
import { toast } from '../lib/toast';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

interface Props {
    onClose: () => void;
}

export const VincularTelegramModal: React.FC<Props> = ({ onClose }) => {
    const [codigo, setCodigo] = useState<string | null>(null);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        apiFetch(`${API_BASE}/auth/telegram/generar-codigo`, { method: 'POST' })
            .then(res => res.json())
            .then((json: ApiResponse<{ codigo: string }>) => {
                if (json.success && json.data) {
                    setCodigo(json.data.codigo);
                } else {
                    toast.error(json.error || 'No se pudo generar el código');
                    onClose();
                }
            })
            .catch(() => {
                toast.error('No se pudo conectar con el servidor');
                onClose();
            })
            .finally(() => setCargando(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const copiar = async () => {
        if (!codigo) return;
        try {
            await navigator.clipboard.writeText(codigo);
            toast.success('Código copiado');
        } catch {
            // clipboard puede no estar disponible (http sin TLS, permisos) — no es crítico
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div
                className="bg-white rounded-xl shadow-xl w-full max-w-sm p-6 text-center"
                onClick={e => e.stopPropagation()}
            >
                <h3 className="text-base font-semibold text-slate-800 mb-1">🔗 Vincular Telegram</h3>
                {cargando ? (
                    <p className="text-sm text-slate-500 py-6">Generando código...</p>
                ) : codigo ? (
                    <>
                        <p className="text-sm text-slate-500 mb-4">
                            Mandale esto al bot de Telegram (vale 10 minutos):
                        </p>
                        <div className="flex items-center justify-center gap-2 mb-4">
                            <code className="text-2xl font-mono font-bold tracking-widest bg-slate-100 rounded-lg px-4 py-2">
                                {codigo}
                            </code>
                        </div>
                        <p className="text-xs text-slate-400 mb-4">
                            <code>/vincular {codigo}</code>
                        </p>
                        <div className="flex gap-2 justify-center">
                            <button
                                onClick={copiar}
                                className="px-3 py-1.5 text-sm border border-slate-200 text-slate-700 rounded-lg hover:bg-slate-100"
                            >
                                Copiar código
                            </button>
                            <button
                                onClick={onClose}
                                className="px-3 py-1.5 text-sm bg-slate-800 text-white rounded-lg hover:bg-slate-700"
                            >
                                Listo
                            </button>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};
